import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { type BaseRequest, type BaseResponse } from '../models'
import { type FreeActivityRecord } from '../../models/FreeActivityRecord'

const _BASE_URL = import.meta.env.REACT_APP_API_BASE_URL!

export const redtailApi = createApi({
  reducerPath: 'redtailApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getRedtailDefaultFreeActivities: builder.query<BaseResponse<FreeActivityRecord[]>, BaseRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/integrations/redtail/default-free-activities`,
      }),
    }),
  }),
})

export const { useGetRedtailDefaultFreeActivitiesQuery } = redtailApi
